module.exports = __webpack_public_path__ + "media/images/result_sets/circles/6n7r9n3r-c8d7986fe9f426c7b8d8ee6b6269cd52.svg";